export default __webpack_public_path__ + "static/media/promo_codes.f6a287ba.svg";